export default "__VITE_ASSET__8d822bf2__"